import React, {useEffect} from 'react';

import ListExplorer from '@/components/explorer/explorerView/listExplorer/ListExplorer';
import VerticalNavigation from '@/components/navigation/verticalNavigation/VerticalNavigation';
import {useCycleHistoryFilteredContext} from '@/contexts/CycleHistoryContext';
import {useCycleHistoryDetailContext} from '@/contexts/CycleHistoryDetailContext';
import {consoleLog} from '@/libs/consoleHelper';

import CycleHistoryPageProfileSelection from './CycleHistoryPageProfileSelection';
import CycleHistoryPageTopMenu from './CycleHistoryPageTopMenu';
import ProfileHistoryDetail from './ProfileHistoryDetail';

function CycleHistoryPageComponent() {
  const {isShowDetail, SetSelectedCycleHistoryList} = useCycleHistoryDetailContext();
  const {filteredCycleHistoryList} = useCycleHistoryFilteredContext();

  useEffect(() => {
    consoleLog('CycleHistoryPage', filteredCycleHistoryList);
  }, [isShowDetail]);

  return (
    <>
      <CycleHistoryPageTopMenu />
      {isShowDetail ? <ProfileHistoryDetail /> : <CycleHistoryPageProfileSelection />}
      <ListExplorer
        listContent={filteredCycleHistoryList}
        callBackSelectedList={SetSelectedCycleHistoryList}
        navigationType={VerticalNavigation.Type.BAR}
        isFullView
        className={` profileHistoryListView ${isShowDetail ? 'hide' : ''}`}
        multipleSelect
        height={360}
      />
    </>
  );
}
export default CycleHistoryPageComponent;
